export default [
    {
        icon: 'GridIcon',
        route: 'discharge',
        title: 'Discharge'
    },
]
